import { getErrorMessage } from "@ark/ui/errors";
import { useFeedback } from "@ark/ui/feedback";
import { useEffect } from "react";

import { sessionManager } from "./session";

export function GlobalErrorBridge() {
  const { message } = useFeedback();

  useEffect(() => {
    const pendingApiErrors = new WeakSet<object>();
    sessionManager.setGlobalErrorHandler((error) => {
      if (isObjectLike(error)) pendingApiErrors.add(error);
    });
    const reportUnhandledApiError = (event: PromiseRejectionEvent) => {
      if (!isObjectLike(event.reason) || !pendingApiErrors.has(event.reason)) {
        return;
      }
      pendingApiErrors.delete(event.reason);
      const text = getErrorMessage(event.reason, "请求失败");
      void message.error(text);
    };
    window.addEventListener("unhandledrejection", reportUnhandledApiError);
    return () => {
      window.removeEventListener("unhandledrejection", reportUnhandledApiError);
      sessionManager.setGlobalErrorHandler(() => undefined);
    };
  }, [message]);

  return null;
}

function isObjectLike(value: unknown): value is object {
  return (
    (typeof value === "object" && value !== null) || typeof value === "function"
  );
}
